import { defineComponent } from 'vue-demi'
import { connect, h, mapProps, mapReadPretty } from '@formily/vue'
import { EventBus } from '../FormItemWithSwitch/utils'
import RateView from './RateView.vue'

/* eslint-disable vue/require-default-prop, vue/require-prop-types */
// eslint-disable-next-line vue/one-component-per-file
const TransformElRate = defineComponent({
  name: 'Rate',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 5,
    },
    disabled: {},
  },
  setup(props, { attrs, slots, listeners, emit }) {
    return () => {
      return h(
        RateView,
        {
          attrs: {
            ...attrs,
          },
          props: {
            ...props,
          },
          on: {
            ...listeners,
            input(value) {
              emit('change', value)
              EventBus.$emit('change', value)
            },
          },
        },
        {
          default: () => {
            return props.value
          },
        },
      )
    }
  },
})
// eslint-disable-next-line vue/one-component-per-file
const ReadPrettyRate = defineComponent({
  setup(props, { attrs }) {
    return () => {
      return h(
        RateView,
        {
          props: { ...props },
          attrs: { ...attrs },
        },
        {
          default: () => {
            return props.value
          },
        },
      )
    }
  },
})

const Rate = connect(
  TransformElRate,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(ReadPrettyRate, { disabled: true }),
)

export default Rate
